/*
 * @Author: Teemo Ding
 * @Date: 2022-03-24 16:03:06
 * @LastEditTime: 2022-06-29 15:01:37
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/Detail/Header/TopLeft/index.tsx
 */
import { get } from 'lodash';
import React from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { useI18n } from 'src/hooks/useRouterChange';
import _TopLeft from 'src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { i18nGet } from 'src/tools/tools';
const TopLeft = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { name, salesChannelName } = props;
  const s = useParams();
  // const uuid = get(s, 'uuid');
  //  const discountUuid = get(s, 'discountUuid');
  const salesChannelUuid = get(s, 'uuid');
  const h = useHistory();
  const goBack = () => {
    h.push(`/salesChannel/discounts/subscriptionBuy/list/${salesChannelUuid}`);
  };

  const b = (name, salesChannelName) => [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: `/salesChannels`,
      name: getI18n('general.sider.salesChannel'),
    },
    {
      url: `/salesChannel/content/${salesChannelUuid}`,
      name: salesChannelName,
    },
    {
      url: '/',
      name: getI18n('general.discounts'),
    },
    {
      url: `/salesChannel/discounts/subscriptionBuy/list/${salesChannelUuid}`,
      name: getI18n('general.subscriptionBuy'),
    },
    {
      url: ``,
      name: name || getI18n('general.addSubscriptionBuy'),
    },
  ];
  return (
    <_TopLeft goBack={goBack} breadcrumbData={b(name, salesChannelName)} />
  );
};
export default TopLeft;
